export default ["src/pages/auth/login/Login.vue"]